// * Bootstrap libraries
import './_bootstrap';
import { initFormStepper } from './_form-stepper';
import { initNodeElements } from './node-elements';
import { initHubTabs } from './_hub-tabs';
import { initHubLandingSearch } from './_hub-landing-search';

// * Any other global site-wide JavaScript should be placed below.

 if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', () => {
         initFormStepper();
         initNodeElements();
         initHubTabs();
         initHubLandingSearch();
     });
 } else {
     initFormStepper();
     initNodeElements();
     initHubTabs();
 }
